import {Component} from '@angular/core';
import {Store} from '@ngrx/store';
import * as wjcCore from '@mescius/wijmo';
import {LoadUserAction} from '../ngrx/actions/user.action';

/**
 * システム管理のコンテナ (シェル)。業務ラインとは別枠。配下でユーザ管理・
 * 役割管理を行う。サイドバーは共有の app-workspace-nav を使う。
 */
@Component({
    standalone: false,
    selector: 'app-system-container',
    templateUrl: './system-container.component.html',
})
export class SystemContainerComponent {
    user: any;

    constructor(private store: Store<any>) {
        this.store.dispatch(new LoadUserAction());
        this.store.select<any>('activePromotionFeature').subscribe((feature: any) => {
            if (wjcCore.isObject(feature.user) && feature.user.loaded) {
                this.user = feature.user.user;
            }
        });
    }
}
